export default function initializeForm() {
    document.querySelectorAll( '.wpcf7-form' ).forEach( function( block ) {
        new ContactFormClass( block );
    } );
}

class ContactFormClass {
    constructor( block ) {
        this.block = block;
        this.init();
    }

    init() {
        this.hoverField();
    }

    hoverField() {
        this.block.querySelectorAll( '.wpcf7-form-control' ).forEach( function( field ) {
            field.addEventListener( 'focus', function() {
                // Pobierz rodzica z klasa .custom-input

                if ( field.closest( '.custom-input' ) ) {
                    field.closest( '.custom-input' ).classList.add( 'custom-input--active' );
                }
            } );

            field.addEventListener( 'blur', function() {
                if ( field.value === '' ) {
                    if ( field.closest( '.custom-input' ) ) {
                        field.closest( '.custom-input' ).classList.remove( 'custom-input--active' );
                    }
                }
            } );
        } );
    }
}
